<template>
  <div class="good-item">
    <div class="good-img">
      <a @click="openProduct(msg)">
        <img :src="msg.pics[0]" :alt="msg.productName" />
      </a>
    </div>
    <div :class="[!this.showBtn&&'pr-n', 'good-price' ,'pr']">
      <div class="ds pa">
        <a @click="openProduct(msg)">
          <y-button text="查看详情" style="margin: 0 5px"></y-button>
        </a>
        <template v-if="!msg.nospec && msg.special_type == 'normal'">
          <!-- 有规格 -->
          <y-button
            :text="msg.special_type == 'drug' ?'加入预约单':'加入购物车'"
            style="margin: 0 5px"
            @btnClick="getSku(msg)"
            classStyle="main-btn"
          ></y-button>
        </template>
        <template v-else-if="!msg.nospec && msg.special_type == 'drug'">
          <y-button
            :text="msg.special_type == 'drug' ?'加入预约单':'加入购物车'"
            style="margin: 0 5px"
            @btnClick="openProduct(msg)"
            classStyle="main-btn"
          ></y-button>
        </template>
        <template v-else>
          <y-button
            :text="msg.special_type == 'drug' ?'加入预约单':'加入购物车'"
            style="margin: 0 5px"
            @btnClick="addCart"
            classStyle="main-btn"
          ></y-button>
        </template>
      </div>
      <p  class="price-info">
        {{msg | priceFilter}} &nbsp;&nbsp;&nbsp;
        <span>{{ msg | marketPriceFilter }}</span>
      </p>
      <!-- <p v-if="!isPrice">{{msg.price | price}}</p> -->
    </div>

    <h4 class="good-title" v-html="msg.item_name">{{msg.item_name}}</h4>
    <p
      v-if="!Array.isArray(msg.distributor_info) && msg.distributor_info"
      class="distributor-info"
    >{{ msg.distributor_info.name }}</p>
    <!-- <h3 v-if="this.showBrief && msg.brief" class="sub-title ellipsis">
      <span>{{msg.brief}}</span>
    </h3>-->
    <p class="good-item__tag">
      <template v-if="isShowActivityTag(msg)">
        <el-tag
          v-if="isShowStypeActivityTag(msg)"
          type="danger"
          effect="dark"
          size="mini"
        >{{msg | filterActivityTag }}</el-tag>
        <el-tag v-else type="danger" size="mini">{{msg | filterActivityTag }}</el-tag>
      </template>
    </p>

    <!-- 选择商品规格 -->
    <template v-if="!msg.nospec && msg.special_type == 'normal'">
      <el-dialog
        title="加入购物车"
        :visible.sync="skuDialogVisible"
        width="370px"
        :before-close="handleClose"
      >
        <div>
          <div class="desc">
            <div class="price-wrap">
              <div class="flex line">
                <div class="tag">商品：</div>
                <span>{{msg.itemName}}</span>
              </div>
            </div>
            <div class="price-wrap">
              <div class="flex line">
                <div class="tag">价格：</div>
                <span class="price">{{msg.price | price}}</span>
              </div>
            </div>
            <!-- 规格 -->
            <div class="classify-container" v-if="!msg.nospec">
              <div
                class="item-hd pt10 classify"
                v-for="(item, index) in msg.item_spec_desc"
                :key="index"
              >
                <span class="dt">{{item.spec_name}}：</span>
                <div class="dd">
                  <div class="choose-attrs-list-wrap">
                    <template v-for="attr in item.spec_values">
                      <div
                        :class="{'active': attr.spec_value_id == selectedAttr[index]}"
                        @click="specBtnClick(attr.spec_value_id, index)"
                        class="choose-attrs-item"
                      >
                        <div class="tick"></div>
                        <span class="label">{{attr.spec_value_name}}</span>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="num">
              <span class="params-name">购买数量：</span>
              <buy-num @edit-num="editNum" :limit="Number(msg.store)" :num="msg.operated_num"></buy-num>
              <span class="store">库存：{{msg.store}}</span>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <y-button
            text="加入购物车"
            :classStyle="btn_disabled ?'disabled-btn':'main-btn'"
            @btnClick="addCart(msg)"
            style="margin: 0 5px"
          ></y-button>
        </span>
      </el-dialog>
    </template>
  </div>
</template>
<script>
import YButton from "/components/YButton";
import BuyNum from "/components/buynum";
import { getCartCount, getskumarketing } from "/api/goods";
import { addCart, productDet } from "/api/goods.js";
import { mapMutations, mapState } from "vuex";
import { isObject } from "/utils";

function factory(row){
  let info = JSON.parse(JSON.stringify(row))
  info.price = (info.price/100).toFixed(2)
  info.member_price = (info.member_price/100).toFixed(2)
  info.market_price = (info.market_price/100).toFixed(2)
  info.promotion_activity_tag = info.promotion_activity

  let promotion_activity = null, act_price = null
  if( info.promotion_activity_tag && info.promotion_activity_tag.length > 1 ) {
    info.promotion_activity_tag.map(tag_item => {
      if(tag_item.tag_type === 'single_group' || tag_item.tag_type === 'normal' || tag_item.tag_type === 'limited_time_sale') {
        promotion_activity = tag_item.tag_type
        act_price = tag_item.activity_price
        return
      }
    })
  } else if( info.promotion_activity_tag && info.promotion_activity_tag.length === 1 ) {
    promotion_activity = info.promotion_activity_tag[0].tag_type
    act_price = info.promotion_activity_tag[0].activity_price
  } else {
    promotion_activity = null
    act_price = null
  }
  act_price = (act_price/100).toFixed(2)
  let price = '', marketPrice = ''
  if (isObject(info.price)) {
    price = info.price.total_price
  } else {
    price = Boolean(+act_price) ? act_price : Boolean(+info.member_price) ? info.member_price : info.price
    marketPrice = Boolean(+act_price) || Boolean(+info.member_price) ? info.price : info.market_price
  }
  if(!row.nospec){ // 多规格
    if(row.spec_items && row.spec_items.length != 0){
      let newPrice = []
      row.spec_items.map((item) => {
        if(item.member_price){
          newPrice.push(item.member_price/100)
        }else{
          newPrice.push(item.price/100)
        }
      })
      newPrice = Array.from(new Set(newPrice))
      let max = Math.max.apply(null, newPrice).toFixed(2);
      let min = Math.min.apply(null, newPrice).toFixed(2);
      if(min < max){
        price = min + '-'+ max
      }else{
        price = min
      }
    }
  }
  return [promotion_activity,price,marketPrice]
}


export default {
  components: {
    YButton,
    BuyNum
  },
  props: {
    msg: {
      salePrice: 0
    },
    showBtn: {
      type: Boolean,
      default: true
    },
    usage: {
      type: String,
      default: ""
    },
    num: {
      type: Number
    },
    isPrice: {
      //是否展示商品价格
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      skuDialogVisible: false,
      renderable: false,
      SKUResult: {},
      productDetail: {
        operated_num: 1,
        store: 1000
      },
      selectedAttr: [],
      btn_flag: null
    };
  },
  filters: {
    priceFilter(info) {
      let list = factory(info);
      return `￥${ list[1] }`;
    },
    marketPriceFilter(info) {
      let list = factory(info);
      if (!Boolean(+list[2])) return "";
      return `￥${list[2]}`;
    },
    filterActivityTag(info) {
      let list = factory(info);
      if (!list[0]) return "";

      let text = "";
      switch (list[0]) {
        case "single_group":
          text = "拼团";
          break;
        case "full_minus":
          text = "满减";
          break;
        case "full_discount":
          text = "满折";
          break;
        case "full_gift":
          text = "满赠";
          break;
        case "normal":
          text = "秒杀";
          break;
        case "limited_time_sale":
          text = "限时特惠";
          break;
        default:
          text = "";
      }
      return text;
    }
  },
  watch: {
    selectedAttr: {
      handler(newVal, oldVal) {
        console.log("selectedAttr", newVal);
        // 选中所有规格后产品信息处理
        if (
          this.msg.item_spec_desc &&
          newVal.length === this.msg.item_spec_desc.length
        ) {
          if (!this.SKUResult.hasOwnProperty(newVal.join("-"))) {
            // 选中组合不在所有可能组合的集合中
            this.btn_disabled = true;
            return;
          }
          for (var key in this.SKUResult) {
            if (newVal.join("-") === key) {
              console.log(
                "选中所有规格后产品信息处理",
                this.SKUResult[key].item_id
              );
              this.msg.item_id = this.itemId = this.SKUResult[key].item_id;
              this.msg.store = this.SKUResult[key].store;
              this.msg.price = this.SKUResult[key].price;
              this.msg.approve_status = this.SKUResult[key].approve_status;
              this._getSkuMarketing(this.itemId);
              if (
                this.SKUResult[key].approve_status !== "onsale" ||
                !this.SKUResult[key].store
              ) {
                this.btn_disabled = true;
                return;
              }
              this.btn_disabled = false; // 恢复默认
              return;
            }
          }
        }
      }
    }
  },

  computed: {
    ...mapState(["login"]),
    btn_disabled: {
      get: function() {
        //console.log('getter')
        if (this.btn_flag !== null) return this.btn_flag;
        if (
          this.msg.item_spec_desc &&
          this.selectedAttr.length !== this.msg.item_spec_desc.length
        )
          return true;
        if (
          this.msg.item_spec_desc &&
          this.selectedAttr.length === this.msg.item_spec_desc.length &&
          this.msg.store > 0
        )
          return false;
        if (this.msg.store > 0) return false;
      },
      set: function(newVal) {
        //console.log('setter', newVal)
        this.btn_flag = newVal;
      }
    }
  },
  methods: {
    ...mapMutations(["UPDATE_CARTCOUNT"]),
    /**
     * 跳转到商品详情页面
     */
    openProduct(row) {
      let href = `/#/goodsDetails?itemId=${row.item_id}&id=${row.distributor_id || 0}`;
      window.open("//" + window.location.host + href);
    },

    /**
     * 无规格商品加如购物车
     */
    addCart() {
      if (!this.login) {
        this.$router.push({ path: "/login" });
        return;
      }

      if (this.msg.special_type === "drug") {
        this.rxAddCart();
        return;
      }

      const params = {
        item_id: this.msg.item_id,
        num: this.msg.operated_num ? this.msg.operated_num : 1,
        shop_type: "distributor",
        cart_type: "cart",
        distributor_id: this.msg.distributor_id ? this.msg.distributor_id : 0
      };
      addCart(params).then(res => {
        this.$message({ message: "添加成功!", type: "success" });
        this._getCartCount();
      });
      this.handleClose();
    },

    /**
     * 药品加入购物车
     */
    rxAddCart() {
      const params = {
        item_id: this.msg.item_id,
        num: this.msg.operated_num ? this.msg.operated_num : 1,
        shop_type: "drug",
        distributor_id: this.msg.distributor_id ? this.msg.distributor_id : 0
      };
      addCart(params).then(({ data }) => {
        this.$message({ message: "添加成功!", type: "success" });
      });
    },

    _getCartCount() {
      const params = { shop_type: "distributor" };
      getCartCount(params).then(({ data }) =>
        this.UPDATE_CARTCOUNT(data.item_count)
      );
    },

    /**
     * 有规格商品点击加入购物车，显示规格弹框，获取商品数据
     */
    getSku(row) {
      this.skuDialogVisible = true;
      let params = {
        distributor_id: row.distributor_id ? row.distributor_id : 0
      };
      productDet(params, row.goodsId || row.itemId).then(res => {
        let result = res.data;
        this.msg = Object.assign(this.msg, result);
        this.SKUResult = this.initSKU(result.spec_items);
      });
    },

    /**
     * 关闭选择规格弹窗
     */
    handleClose() {
      this.skuDialogVisible = false;
      this.btn_disabled = true; // 恢复默认
      this.selectedAttr = [];
    },

    specBtnClick(id, index) {
      console.log(342143214312, id, index);
      this.$set(this.selectedAttr, index, id);
    },

    // 初始化得到结果集
    initSKU(data) {
      let tmp = [];
      data.forEach(v => {
        let skuKeyArray = [];
        let skuValueArray = [];
        v.item_spec.forEach(vv => {
          skuKeyArray.push(vv.spec_value_id);
          skuValueArray.push(vv.spec_value_name);
        });
        tmp[skuKeyArray.join("-")] = {
          ...v,
          text: skuValueArray.join(","),
          store: Number(v.store)
        };
      });
      console.table("sku组合可能性", tmp);
      return tmp;
    },

    _getSkuMarketing(itemId) {
      const params = { item_id: itemId, distributor_id: this.distributor_id };
      getskumarketing(params).then(res => {
        const { data } = res;
        this.msg.promotion_activity = data.promotion_activity;
      });
    },

    /**
     * 编辑加入购物车数量
     */
    editNum(item, num, id, isChecked) {
      this.msg.operated_num = num;
    },

    /**
     * 判断是否显示活动标签
     */
    isShowActivityTag(info) {
      let type = null;
      if (info.promotion_activity && info.promotion_activity.length > 1) {
        info.promotion_activity.map(tag_item => {
          if (
            tag_item.tag_type === "single_group" ||
            tag_item.tag_type === "normal" ||
            tag_item.tag_type === "limited_time_sale"
          ) {
            type = tag_item.tag_type;
            return;
          }
        });
      } else if (
        info.promotion_activity &&
        info.promotion_activity.length === 1
      ) {
        type = info.promotion_activity[0].tag_type;
      } else {
        type = null;
      }
      return type;
    },
    isShowStypeActivityTag(info) {
      let type = this.isShowActivityTag(info);
      if (type === "single_group") return true;
      return false;
    }
  }
};
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
@import "../assets/style/mixin";
@import "../assets/style/theme";

.good-item {
  background: #fff;
  width: 25%;
  transition: all 0.5s;
  height: 430px;

  &:hover {
    /*transform: translateY(-3px);*/
    box-shadow: 1px 1px 20px #999;
    .good-price {
      &.pr-n {
        p {
          display: block;
        }
      }
      p {
        display: none;
      }
    }
    .ds {
      display: flex;
    }
  }

  .ds,
  .pr-n .pa {
    @extend %block-center;
    width: 100%;
    display: none;
  }

  &__tag {
    padding: 0 14px;
    text-align: left;
    height: 20px;
    margin-bottom: 10px;
    margin-top: 5px;
  }

  .good-img {
    img {
      margin: 50px auto 10px;
      @include wh(206px);
      display: block;
    }
  }
  .good-price {
    // margin: 10px 0;
    margin-top: 10px;
    margin-bottom: 5px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    color: #d44d44;
    font-family: Arial;
    font-size: 18px;
    font-weight: 700;
    .price-info {
      span {
        font-size: 12px;
        text-decoration: line-through;
        color: #818181;
      }
    }
  }
  .good-title {
    line-height: 1.2;
    font-size: 16px;
    color: #424242;
    margin: 0 auto;
    padding: 0 14px;
    // text-align: center;
    overflow: hidden;
  }
  .distributor-info {
    line-height: 1.2;
    font-size: 12px;
    color: #999;
    padding: 10px 14px;
  }
}
.desc {
  width: 450px;
  margin-left: 10px;
  h4 {
    font-size: 24px;
    line-height: 1.25;
    color: #000;
    margin-bottom: 13px;
  }
  h6 {
    font-size: 14px;
    line-height: 1.5;
    color: #bdbdbd;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .sku-custom-title {
    overflow: hidden;
    padding: $edge-size * 2 0;
    position: relative;
  }
  .params-name {
    min-width: 45px;
    padding-right: 20px;
    font-size: 14px;
    color: $gray-666;
    line-height: 36px;
  }
  .num {
    display: flex;
    align-items: center;
    .store {
      margin-left: $edge-size * 4;
    }
  }
  .buy {
    position: relative;
    margin-top: $edge-size * 2;
    .js-page-shoucang {
      cursor: pointer;
      margin-left: $edge-size * 2;
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto;
      right: 0;
      .star {
        font-size: 20px;
        color: $primary-color;
      }
    }
  }
}
.price-wrap {
  padding: $edge-size;
  .line {
    padding: $edge-size;
    line-height: 30px;
    width: 330px;
    &:nth-child(2) {
      justify-content: space-between;
      .act-wrap {
        flex: 2;
      }
      .handle {
        cursor: pointer;
        color: $special-color;
        font-size: $font-size-small;
      }
    }
  }
  .tag {
    font-size: $font-size-small;
    color: $gray-666;
    min-width: 75px;
  }
  .price {
    color: $primary-color;
    font-weight: 700;
    font-size: $font-size * 2;
    line-height: $font-size * 2;
  }
}
.classify-container {
  padding: 0 0 0 10px;
  .classify {
    .pt10 {
      padding-top: 10px;
    }
    .dt {
      display: inline-block;
      min-width: 75px;
      font-size: 14px;
      color: $gray-666;
      line-height: 36px;
    }
    .dd {
      display: inline-flex;
      flex-wrap: wrap;
      width: 230px;
      // width: 560px;
    }
    .choose-attrs-item {
      line-height: 40px;
      cursor: pointer;
      // -webkit-user-select: none;
      // -moz-user-select: none;
      // -ms-user-select: none;
      // user-select: none;
      position: relative;
      display: inline-block;
      padding: 0 15px;
      font-size: 14px;
      color: #666;
      border: 1px solid #ddd;
      margin-right: 10px;
      margin-bottom: 10px;
    }
    .choose-attrs-item.active {
      border: 1px solid $primary-color;
      .tick {
        display: block;
      }
    }
    .inactive {
      border: 1px dashed #ccc;
      color: #999;
      pointer-events: none;
    }
    .tick {
      position: absolute;
      right: 0;
      bottom: 0;
      display: none;
      width: 12px;
      height: 12px;
      background: url("../../static/images/tick.png") no-repeat center;
    }
  }
}
</style>
<style lang="scss">
@import "../assets/style/theme";
.el-dialog__header {
  border-bottom: 1px solid #d8d8d8;
}
.el-dialog__title {
  color: $gray-666;
}
.el-dialog__footer {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// mallGoods.vue?115175de